import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import CartListDynamic from '../components/CartListDynamic';
import BillingForm from '../components/billing-form/BillingForm';
import PurchaseSuccess from '../components/PurchaseSuccess';
import PurchaseError from '../components/PurchaseError';
import AmountSelector from '../components/AmountSelector';
import DonationDedicationForm from '../components/DonationDedicationForm';
import { CURRENCIES } from '../constants/currencies';

class StreamPpvView extends Component {

	constructor(props) {
		super(props);
		this.state = {
			billingStage: false,
		}
	}

	handleClick = event => {
		event.preventDefault();
		const { shopStore } = this.props;
		shopStore.setCart([]);
	}

	render() {			
		const { shopStore } = this.props;
		const cashsale = shopStore.cashsale.get();
		const purchaseError = shopStore.purchaseError.get();
		const context = window.tkcWidgetContext;
		if (purchaseError) {
			return <PurchaseError message={purchaseError} />
	  	} else if (cashsale) {			
			return (
				<span>
					<PurchaseSuccess 
						orderNumber={cashsale.ordernumber} 
						total={cashsale.total} 
						isDonation={false}
						currencyCode={cashsale.currencysymbol}
					/>
					{/*<PurchaseSuccess 
						orderNumber={1} 
						total={100.00} 
						isDonation={false}
						currencyCode={'USD'}
					/>*/}					
					<div className="container my-4">				
						<div className="row">
							<div className="col-12 text-center">
								<h5>You now have access to the live stream.</h5>
								<a 
										href={context.streamUrl} 
										className="btn btn-lg tkc-btn-red font-weight-bold px-5 mb-4"
								>
									Go To Stream
								</a>								
							</div>
						</div>
					</div>
				</span>
			);
		} else if (shopStore.cart.get('items').length === 0) {
			return (
				<AmountSelector />
			);
		}		
		return (
			<div className="container">				
				<div className="row">
					<div className="col-md-12">
						<a href="" onClick={this.handleClick}>
							&lt;&lt; Back to amount
						</a>
					</div>
				</div>
				<hr />
				<br />
				<div className="row">
					<div className="col-lg-4 order-lg-2 mb-4">
						<CartListDynamic />						
					</div>
					{shopStore.cart.get('hypoCashsale') &&
						<div className="col-lg-8 order-lg-1">
							<BillingForm />					
						</div>									
					}
				</div>
			</div>
		);
	}

}

export default inject('shopStore')(observer(StreamPpvView));




// WEBPACK FOOTER //
// ./src/views/StreamPpvView.js